
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'

export default Vue.extend({
  mixins: [mixins.UiInput],

  props: {
    //* Датасет для тестов
    dataset: {
      type: String,
      default: undefined
    },

    //* дополнительные классы для инпута
    staticClass: {
      type: String,
      default: ''
    },

    //* Заголовок инпута
    title: {
      type: String,
      required: false,
      default: () => ''
    },

    //* Описание
    placeholder: {
      type: String,
      default: () => ''
    },

    //* Код поля
    code: {
      type: String,
      required: true
    },

    //* Передаваемое значение
    value: {
      type: String,
      required: true,
      default: () => ''
    },

    //* Обязательность поля
    required: {
      type: Boolean,
      default: () => false
    },

    //* Активность поля
    disabled: {
      type: Boolean,
      default: () => false
    },

    //* Автофокус на поле
    autofocus: {
      type: Boolean,
      default: false
    },

    //* Тип инпута
    //* @params text - для текстовых инпутов
    //* @params password - для пароля
    //* @params selphone - для поля ввода телефона с выподающим списком стран
    type: {
      type: String,
      required: false,
      default: () => ''
    },

    //* Маска на значение
    mask: {
      type: Object,
      default: () => { }
    },

    //* Мутация, используемая директивой маски вместо кода поля
    maskMutation: {
      type: String,
      default: ''
    },

    //* inputmode поля
    mode: {
      type: String,
      default: undefined
    },

    //* Новый пароль для проверки
    newPassword: {
      type: String,
      default: ''
    },

    //* Триггер валидации
    triggerValidate: {
      type: Boolean,
      default: false
    },

    //* Триггер анимации
    triggerAnimation: {
      type: Boolean,
      default: false
    }
  }
})
